import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogTitle, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import { Col, Form, Row } from 'react-bootstrap';
import Home from '../home/Home';
import BillingService from '../../Services/billing/BillingService';
import Snacbar from '../Snacbar';
import { getDate, getUserId } from '../Utils/Common';
import HashLoader from "react-spinners/HashLoader";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';

const jobentrylablestyle = {
    color: 'grey',
    fontWeight: 'bolder', fontFamily: 'Times New Roman',
}

const ItemPap = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    height: '400px'
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    height: '400px'
}));
const ItemPap2 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    border: '1px solid black',
    height: '400px'
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgb(61, 195, 177)',
        color: theme.palette.common.black,
        textAlign: 'center',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        color: 'darkblue',
        fontFamily: 'Times New Roman',
        textAlign: 'center'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hoverOpacity,
    },
}));
function ConsleBillGen() {

    const [CnslBillGenValues, setCnslBillGenValues] = useState({
        cbg_importer: '', cbg_jobNo: '', cbg_Billname: '', cbg_BillPayby: '',
        cbg_BillPaidto: '', cbg_Paymenttype: '', cbg_vouchertype: '',
        cbg_printedtype: '', cbg_RecVoucherNo: '', cbg_VoucherDate: getDate(),
        cbg_BillAmount: '', cbg_Remraks: '', billId: '', disableJobno: '',
    });
    const [consigmnt, setConsigment] = useState('');
    const [CnslBillGenError, setCnslBillGenError] = useState({
        cbg_Billname: false, cbg_BillPayby: false, cbg_Paymenttype: false, cbg_vouchertype: false,
        cbg_printedtype: false, cbg_BillAmount: false, cbg_BillPaidto: false
    });
    const [jobentryDetails, setjobentryDetails] = useState({
        txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
        ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
        txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
        lbl_asHawbNo: 'HAWB.No',
    })

    const [open, setOpen] = useState(false);
    const [severity, setseverity] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setloading] = useState(false)
    const [DrpImporter, setDrpImporter] = useState([]);
    const [nonConsole, setnonConsole] = useState([]);
    const [ConsoleBilling, setConsoleBilling] = useState([]);

    const [NoBill_Filtereddetails, setNoBill_Filtereddetails] = useState([]);
    const [Bill_Filtereddetails, setBill_Filtereddetails] = useState([]);
    const [selected, setSelected] = useState([]);

    const [consoleDetails, setconsoleDetails] = useState([]);
    const [billName, setbillName] = useState([]);
    const [billType, setbillType] = useState([]);
    const [billPaidby, setbillPaidby] = useState([]);
    const [VoucherType, setVoucherType] = useState([]);
    const [BillPaidTo, setBillPaidTo] = useState([]);
    const [PrintedType, setPrintedType] = useState([]);
    const [OpenViewJob, setOpenViewJob] = useState(false);

    const [saveDsa, setsaveDsa] = useState(true);
    const [UpdateDsa, setUpdateDsa] = useState(true);
    const [DeleteDsa, setDeleteDsa] = useState(true);

    const [save, setsave] = useState(false);
    const [Update, setUpdate] = useState(false);
    const [Delete, setDelete] = useState(false);
    //dialog
    const CloseViewJobHandle = () => {
        setOpenViewJob(false);
    }
    const OpenViewJobHandle = () => {
        setOpenViewJob(true);
    }
    //onClick
    const searchkeydown = (e) => {
        if (e.key === 'Enter') {
            setnonConsole([]);
            setconsoleDetails([]);
            getJobNoConsoleNonUpload(CnslBillGenValues.cbg_importer, CnslBillGenValues.cbg_jobNo);
        }
    }

    const validate = () => {
        if (CnslBillGenValues.cbg_Billname !== '') {
            if (CnslBillGenValues.cbg_BillPayby !== '') {
                if (CnslBillGenValues.cbg_BillPaidto !== '') {
                    if (CnslBillGenValues.cbg_Paymenttype !== '') {
                        if (CnslBillGenValues.cbg_vouchertype !== '') {
                            if (CnslBillGenValues.cbg_printedtype !== '') {
                                if (CnslBillGenValues.cbg_BillAmount !== '') {
                                    return true;
                                }
                                else {
                                    setCnslBillGenError({ ...CnslBillGenError, cbg_BillAmount: true });
                                    document.getElementById('billAmount').focus();
                                    setOpen(true); setseverity('warning'); setMessage('Please Enter Billing Amount Warning ..!!');
                                }
                            }
                            else {
                                setCnslBillGenError({ ...CnslBillGenError, cbg_printedtype: true });
                                document.getElementById('printedType').focus();
                                setOpen(true); setseverity('warning'); setMessage('Please Select Printed Type Warning ..!!');
                            }
                        }
                        else {
                            setCnslBillGenError({ ...CnslBillGenError, cbg_vouchertype: true });
                            document.getElementById('vocherType').focus();
                            setOpen(true); setseverity('warning'); setMessage('Please Select Voucher Type Warning ..!!');
                        }
                    }
                    else {
                        setCnslBillGenError({ ...CnslBillGenError, cbg_Paymenttype: true });
                        document.getElementById('paymentType').focus();
                        setOpen(true); setseverity('warning'); setMessage('Please Select Payment Type Warning ..!!');
                    }
                }
                else {
                    setCnslBillGenError({ ...CnslBillGenError, cbg_BillPaidto: true });
                    document.getElementById('paidto').focus();
                    setOpen(true); setseverity('warning'); setMessage('Please Select Bill Paid To Warning ..!!');
                }
            }
            else {
                setCnslBillGenError({ ...CnslBillGenError, cbg_BillPayby: true });
                document.getElementById('paidby').focus();
                setOpen(true); setseverity('warning'); setMessage('Please Select Bill Paid By Warning ..!!');
            }
        }
        else {
            setCnslBillGenError({ ...CnslBillGenError, cbg_Billname: true });
            document.getElementById('billName').focus();
            setOpen(true); setseverity('warning'); setMessage('Please Select Bill Name Warning ..!!');
        }
        return false;
    }

    const saveConsoleBIling = () => {
        if (validate() === true) {
            setsaveDsa(true);
            setsave(true);
            let details = {
                consignmentId: consigmnt, billName: CnslBillGenValues.cbg_Billname, billAmount: CnslBillGenValues.cbg_BillAmount,
                billPaidDate: CnslBillGenValues.cbg_VoucherDate, billPaidBy: CnslBillGenValues.cbg_BillPayby, billPaidTo: CnslBillGenValues.cbg_BillPaidto, paymentType: CnslBillGenValues.cbg_Paymenttype,
                paymentVoucharNo: CnslBillGenValues.cbg_RecVoucherNo, voucherType: CnslBillGenValues.cbg_vouchertype, printedType: CnslBillGenValues.cbg_printedtype,
                createdBy: getUserId(), remarks: CnslBillGenValues.cbg_Remraks
            }
            BillingService.insertBilling(details).then((res) => {
                if (res.data.message.toString() === 'SUCCESS') { setOpen(true); setseverity('success'); setMessage(res.data.message); }
                else { setOpen(true); setseverity('error'); setMessage('Failed To Save' + res.data.message); } reSet(); getBilling(consigmnt);
            }).catch(error => { setOpen(true); setseverity('error'); setMessage('Failed To Save' + error.message); reSet(); });
        }
    }
    const UpdateConsoleBIling = () => {
        if (validate() === true) {
            setUpdateDsa(true);
            setUpdate(true);
            let details = {
                billId: CnslBillGenValues.billId, billName: CnslBillGenValues.cbg_Billname, billAmount: CnslBillGenValues.cbg_BillAmount,
                billPaidDate: CnslBillGenValues.cbg_VoucherDate, billPaidBy: CnslBillGenValues.cbg_BillPayby, billPaidTo: CnslBillGenValues.cbg_BillPaidto, paymentType: CnslBillGenValues.cbg_Paymenttype,
                paymentVoucharNo: CnslBillGenValues.cbg_RecVoucherNo, voucherType: CnslBillGenValues.cbg_vouchertype, printedType: CnslBillGenValues.cbg_printedtype,
                createdBy: getUserId(), remarks: CnslBillGenValues.cbg_Remraks
            }
            BillingService.updateBilling(details).then((res) => {
                if (res.data.message.toString() === 'SUCCESS') { setOpen(true); setseverity('success'); setMessage(res.data.message); }
                else { setOpen(true); setseverity('error'); setMessage('Updation Failed ' + res.data.message); } reSet(); getBilling(consigmnt);
            }).catch(error => { setOpen(true); setseverity('error'); setMessage('Updation Failed ' + error.message); reSet(); });
        }
    }
    const deleteBilling = () => {
        if (validate() === true) {
            setDeleteDsa(true);
            setDelete(true);
            BillingService.deleteBilling(CnslBillGenValues.billId).then((res) => {
                if (res.data.message.toString() === 'SUCCESS') { setOpen(true); setseverity('success'); setMessage(res.data.message); }
                else { setOpen(true); setseverity('error'); setMessage('Failed To Delete' + res.data.message); } reSet(); getBilling(consigmnt);
            }).catch(error => { setOpen(true); setseverity('error'); setMessage('Failed To Delete' + error.message); reSet(); });
        }
    }
    const refresh = () => {
        setCnslBillGenValues({
            ...CnslBillGenValues, cbg_importer: '', cbg_jobNo: '', cbg_Billname: '', cbg_BillPayby: '', disableJobno: '',
            cbg_BillPaidto: '', cbg_Paymenttype: '', cbg_vouchertype: '',
            cbg_printedtype: '', cbg_RecVoucherNo: '', cbg_VoucherDate: getDate(),
            cbg_BillAmount: '', cbg_Remraks: '', billId: ''
        }); setConsigment(''); getData();
        setCnslBillGenError({
            ...CnslBillGenError, cbg_Billname: false, cbg_BillPayby: false, cbg_Paymenttype: false, cbg_vouchertype: false,
            cbg_printedtype: false, cbg_BillAmount: false, cbg_BillPaidto: false
        }); setConsoleBilling([]);
        setjobentryDetails({
            ...jobentryDetails, txt_asJobNo: '', txt_asMawbNo: '', txt_asImporterName: '', txt_asImporterCode: '', txt_asImporterState: '',
            ta_asimporterAddress: '', txt_asTransitType: '', txt_asAirlinesName: '', txt_asOriginCountry: '', txt_asOriginPort: '',
            txt_asClearancePort: '', txt_asArrivalDate: '', txt_asHawbNo: '', lbl_asMawbNo: 'MAWB.No', lbl_asAirlinesName: 'AirlinesName',
            lbl_asHawbNo: 'HAWB.No',
        })
        setsaveDsa(true); setUpdateDsa(true); setDeleteDsa(true);
        setsave(false); setUpdate(false); setDelete(false);
    }
    const reSet = () => {
        setCnslBillGenValues({
            ...CnslBillGenValues, cbg_importer: '', cbg_jobNo: '', cbg_Billname: '', cbg_BillPayby: '',
            cbg_BillPaidto: '', cbg_Paymenttype: '', cbg_vouchertype: '',
            cbg_printedtype: '', cbg_RecVoucherNo: '', cbg_VoucherDate: getDate(),
            cbg_BillAmount: '', cbg_Remraks: '', billId: '', disableJobno: '',
        });
        setCnslBillGenError({
            ...CnslBillGenError, cbg_Billname: false, cbg_BillPayby: false, cbg_Paymenttype: false, cbg_vouchertype: false,
            cbg_printedtype: false, cbg_BillAmount: false, cbg_BillPaidto: false
        });
        setsaveDsa(false); setUpdateDsa(true); setDeleteDsa(true);
        setsave(false); setUpdate(false); setDelete(false);
    }
    const cbg_importerChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_importer: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
        getJobNoConsoleNonUpload(e.target.value, CnslBillGenValues.cbg_jobNo)
    }
    const cbg_jobNoChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_jobNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
        setnonConsole([]);
        setconsoleDetails([]);
        var consigmnt, importer_iec_no = '';
        if (e.target.value === '') {
            consigmnt = '-1'
        }
        else {
            consigmnt = e.target.value
        }
        if (CnslBillGenValues.cbg_importer === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = CnslBillGenValues.cbg_importer; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '11' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonConsole(res.data); setNoBill_Filtereddetails(res.data) });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setconsoleDetails(res.data); setBill_Filtereddetails(res.data) });
        // getJobNobasedSrch(e.target.value, CnslBillGenValues.cbg_importer)
    }
    const cbg_BillnameChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_Billname: e.target.value.replace(/[`~!@#$%^*()_|+\-{}=[?;:'",.<>]/gi, '') })
        console.log('onchng===>' + JSON.stringify(e.target.value))
    }
    const cbg_BillPaybyChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_BillPayby: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const cbg_BillPaidtoChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_BillPaidto: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const cbg_PaymenttypeChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_Paymenttype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const cbg_vouchertypeChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_vouchertype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const cbg_printedtypeChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_printedtype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const cbg_RecVoucherNoChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_RecVoucherNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const cbg_VoucherDateChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_VoucherDate: e.target.value })
    }
    const cbg_BillAmountChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_BillAmount: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }
    const cbg_RemraksChangeHandle = (e) => {
        setCnslBillGenValues({ ...CnslBillGenValues, cbg_Remraks: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
    }

    const drpData = () => {
        BillingService.getImporterDetails().then((res) => {
            setDrpImporter(res.data)
            console.log('onchngres==>' + JSON.stringify(res))
        });
        BillingService.getbillName('-1').then((res) => { setbillName(res.data); });
        BillingService.getBillPaymentType().then((res) => { setbillType(res.data); });
        BillingService.getBillPaidBy().then((res) => { setbillPaidby(res.data); });
        BillingService.getVoucherType().then((res) => { setVoucherType(res.data); });
        BillingService.getBillPaidTo().then((res) => { setBillPaidTo(res.data); });
        BillingService.getPrintedType().then((res) => { setPrintedType(res.data); });
    }
    const getData = async () => {
        BillingService.getnonAudit('11').then(res => { setnonConsole(res.data); setNoBill_Filtereddetails(res.data) });
        BillingService.getAudit('11').then(res => { setconsoleDetails(res.data); setBill_Filtereddetails(res.data) });
    }

    const getJobNoConsoleNonUpload = (val, val2) => {
        setnonConsole([]);
        setconsoleDetails([]);
        var consigmnt, importer_iec_no = '';
        if (val2 === '') {
            consigmnt = '-1'
        }
        else {
            consigmnt = val2
        }
        if (val === '') { importer_iec_no = '-1'; }
        else { importer_iec_no = val; }
        let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '11' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonConsole(res.data); setNoBill_Filtereddetails(res.data) });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setconsoleDetails(res.data); setBill_Filtereddetails(res.data) });
    }
    // const getJobNobasedSrch = (val, val2) => {
    //     setnonConsole([]);
    //     setconsoleDetails([]);
    //     var consigmnt, importer_iec_no = '';
    //     if (val2 === '') {
    //          consigmnt = '-1' 
    //         }
    //     else { 
    //         consigmnt = val 
    //     }
    //     if (val === '') { importer_iec_no = '-1'; }
    //     else { importer_iec_no = val2; }
    //     let details = { importer_iec_no: importer_iec_no, consignmentNumber: consigmnt, status: '11' }
    //     BillingService.getJobNoBasedImpCMNonUploadCL(details).then((res) => { setnonConsole(res.data);setNoBill_Filtereddetails(res.data) });
    //     BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setconsoleDetails(res.data);  setBill_Filtereddetails(res.data) });
    // }

    useEffect(() => {
        setloading(true)
        setTimeout(() => {
            setloading(false)
        }, 1000)
        const getData = async () => {
            BillingService.getnonAudit('11').then(res => { setnonConsole(res.data); setNoBill_Filtereddetails(res.data) });
            BillingService.getAudit('11').then(res => { setconsoleDetails(res.data); setBill_Filtereddetails(res.data) });
        }
        drpData();
        getData();
    }, []);

    const handleClose = () => {
        setOpen(false);
    }

    const getBilling = (val) => {
        setConsoleBilling([])
        BillingService.getBilling(val, '-1').then(res => { setConsoleBilling(res.data) });
    }

    const jobNonBilling = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);
        setCnslBillGenValues({
            ...CnslBillGenValues,
            cbg_importer: '', cbg_jobNo: '', cbg_Billname: '', cbg_BillPayby: '',
            cbg_BillPaidto: '', cbg_Paymenttype: '', cbg_vouchertype: '',
            cbg_printedtype: '', cbg_RecVoucherNo: '', cbg_VoucherDate: getDate(),
            cbg_BillAmount: '', cbg_Remraks: '', billId: '', disableJobno: item.consignmentNumber,
        });
        setsaveDsa(false); setUpdateDsa(true); setDeleteDsa(true);
        setsave(false); setUpdate(false); setDelete(false);
        setConsigment(item.consignmentNumber);
        getBilling(item.consignmentNumber);
        BillingService.getJobDetailsAssign(item.consignmentNumber).then((res) => {
            const data = res.data;
            const lastResult = data.map((item) => item);
            var MawbNo, AirlinesName, HawbNo = '';
            if (lastResult[0].transitTypeName === 'AIR') {
                MawbNo = 'MAWB.No';
                AirlinesName = 'AirlinesName';
                HawbNo = 'HAWB.No'
            } else if (lastResult[0].transitTypeName === 'SEA') {
                MawbNo = 'MBL.No';
                AirlinesName = 'ShipmentCompany';
                HawbNo = 'HBL.No'
            }
            if (lastResult[0] === '') {

            }
            setjobentryDetails({
                ...jobentryDetails, txt_asJobNo: lastResult[0].consignmentNumber, txt_asMawbNo: lastResult[0].wayBillNumber, txt_asImporterName: lastResult[0].importer_name,
                txt_asImporterCode: lastResult[0].importer_iec_no, txt_asImporterState: lastResult[0].deliveryStateName, ta_asimporterAddress: lastResult[0].importerAddress,
                txt_asTransitType: lastResult[0].transitTypeName, txt_asAirlinesName: lastResult[0].shipmentCompanyName, txt_asOriginCountry: lastResult[0].countryName,
                txt_asOriginPort: lastResult[0].origin_portName, txt_asClearancePort: lastResult[0].destinationName, txt_asArrivalDate: lastResult[0].expectedArrivalDateTime,
                txt_asHawbNo: lastResult[0].hawb_no, lbl_asMawbNo: MawbNo, lbl_asAirlinesName: AirlinesName, lbl_asHawbNo: HawbNo
            })
        });
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;
    const editconsole = (item) => {

        setCnslBillGenValues({
            ...CnslBillGenValues, cbg_Billname: item.billName, cbg_BillPayby: item.billPaidBy,
            cbg_BillPaidto: item.billPaidTo, cbg_Paymenttype: item.paymentType, cbg_vouchertype: item.voucherType,
            cbg_printedtype: item.printedType, cbg_RecVoucherNo: item.paymentVoucharNo, cbg_VoucherDate: item.billPaidDate,
            cbg_BillAmount: item.billAmount, cbg_Remraks: item.remarks, billId: item.billId
        });
        setsaveDsa(true); setUpdateDsa(false); setDeleteDsa(false);
        setsave(false); setUpdate(false); setDelete(false);
    }
    //table search
    const nonbillJobSrch = () => {
        return <input className="searchBoxes" style={{ width: '50%' }} onChange={(e) => { nonbillJobSrchOnchange(e.target.value) }} placeholder="Search" />
    }
    const nonbillJobSrchOnchange = (searchedVal) => {
        const FilterValues = nonConsole.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (searchedVal.length < 1) {
            setNoBill_Filtereddetails(nonConsole)
        } else {
            setNoBill_Filtereddetails(FilterValues)
        }
    }
    //table search
    const billJobSrch = () => {
        return <input className="searchBoxes" style={{ width: '50%' }} onChange={(e) => { billJobSrchOnchange(e.target.value) }} placeholder="Search" />
    }
    const billJobSrchOnchange = (searchedVal) => {
        const FilterValues = consoleDetails.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (searchedVal.length < 1) {
            setBill_Filtereddetails(consoleDetails)
        } else {
            setBill_Filtereddetails(FilterValues)
        }
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/jobAudit');
    }
    const ForwordBotton = () => {
        navigate('/1stlvl');
    }
    return (
        <div>
            <Home />
            {/* view Job */}
            <Dialog open={OpenViewJob} onClose={CloseViewJobHandle} fullWidth={true} maxWidth='lg'>
                <DialogTitle className='p-1' style={{ backgroundColor: '#81d4fa', fontWeight: 'bolder' }}><center style={{ fontFamily: 'Times New Roman' }}>JobEntry Details</center></DialogTitle>
                <Paper sx={{ height: 230 }}>
                    <Row className='mt-1 p-2'>
                        <Col className='jobentrAssign' xs={4}>
                            <Row xs={5}>
                                <Col xs={5}><label style={jobentrylablestyle}>Job.No</label></Col>
                                <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asJobNo} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>{jobentryDetails.lbl_asMawbNo}</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asMawbNo} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer Name</label></Col>
                                <Col className='jobentrAssign' ><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterName} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer Code</label></Col>
                                <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterCode} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer State</label></Col>
                                <Col className='jobentrAssign summurry'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asImporterState} /></Col>
                            </Row>
                        </Col>

                        <Col className='jobentrAssign'>
                            <Row xs={5}>
                                <Col xs={5}><label style={jobentrylablestyle}>Importer Address</label></Col>
                                <Col className='jobentrAssign'><textarea rows="4" cols="17" disabled className='textAreaummurry scrollbarPrime'>{':' + jobentryDetails.ta_asimporterAddress}</textarea></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Transit Type</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asTransitType} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>{jobentryDetails.lbl_asAirlinesName}</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asAirlinesName} /></Col>
                            </Row>
                        </Col>
                        <Col className='jobentrAssign'>
                            <Row xs={5}>
                                <Col xs={4}><label style={jobentrylablestyle}>Origin Country</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginCountry} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Origin Port</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asOriginPort} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Clearance Port</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asClearancePort} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>Arrival Date</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asArrivalDate} /></Col>
                            </Row>
                            <Row xs={5} className='mt-2'>
                                <Col xs={4}><label style={jobentrylablestyle}>{jobentryDetails.lbl_asHawbNo}</label></Col>
                                <Col className='jobentrAssign'><input disabled className='Inptsummurry' value={':' + jobentryDetails.txt_asHawbNo} /></Col>
                            </Row>
                        </Col>
                    </Row>
                </Paper>
            </Dialog>
            <Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
            <div style={{ paddingLeft: '80px' }}>
            <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                {loading ?
                    <div className="loaderCss">
                        <HashLoader
                            color={"#296cbc"}
                            loading={loading}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                    :
                    <Grid container>
                        <Grid item xs={2}>
                            <ItemPap1>
                                {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt'  size="small" >
                             <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px',marginLeft:'5px' }}/> </ToggleButton> */}
                                <lable style={{ fontSize: '14px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', fontFamily: 'Times New Roman', marginBottom: '1%', marginLeft: '18px' }}>Non Billing Job</lable>
                                <TableContainer sx={{ maxHeight: 370 }} className='scrollbarPrime'>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1'>Sl.No</StyledTableCell>
                                                <StyledTableCell className='p-1'>Job No {nonbillJobSrch()}</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {NoBill_Filtereddetails.map((item) => {
                                                const isItemSelected = isSelected(item.consignmentId);
                                                return (
                                                    <StyledTableRow hover key={item.consignmentNumber} selected={isItemSelected} tabIndex={-1} onClick={() => jobNonBilling(item)}>
                                                        <StyledTableCell className='p-1'>{item.serialNumber}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.consignmentNumber}</StyledTableCell>
                                                    </StyledTableRow>)
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap1>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xs={9}>
                                    <ItemPap>
                                        <div className=' p-1 mt-2 mb-2'>
                                            <Row>
                                                <lable style={{ fontFamily: 'Times New Roman', fontSize: '20px', fontWeight: 'bold', color: 'red', marginBottom: '1%' }}>CONSOLE BILLING</lable>
                                                <Col xs={1}>
                                                    <label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder' }}>JOB</label>
                                                </Col>
                                                <Col xs={3}>
                                                    <Form.Control type='number' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px' }} onKeyDown={searchkeydown} value={CnslBillGenValues.cbg_jobNo} onChange={cbg_jobNoChangeHandle} />
                                                </Col>
                                                <Col xs={2}><label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder' }}>IMPORTER</label></Col>
                                                <Col xs={3}>
                                                    <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center' }}
                                                        value={CnslBillGenValues.cbg_importer} onChange={cbg_importerChangeHandle}>
                                                        <option value={''}></option>
                                                        {DrpImporter.map((item) => (
                                                            <option value={item.importer_iec_no}>{item.importer_name}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                                <Col xs={1}>
                                                    <label style={{ fontFamily: 'Times New Roman', color: 'darkblue', fontWeight: 'bolder' }}>JOB_No</label>
                                                </Col>
                                                <Col xs={2}>
                                                    <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', color: 'darkred', fontWeight: 'bolder', fontSize: '25px' }} disabled value={CnslBillGenValues.disableJobno} />
                                                </Col>
                                            </Row>
                                        </div>
                                        <Row>
                                            <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Bill Name</label>
                                                <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bolder' }} isInvalid={CnslBillGenError.cbg_Billname}
                                                    value={CnslBillGenValues.cbg_Billname} onChange={cbg_BillnameChangeHandle} id='billName' required>
                                                    <option value={''}></option>
                                                    {billName.map((item) => (
                                                        <option value={item.billName}>{item.billName}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Payment Type</label>
                                                <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bolder' }} isInvalid={CnslBillGenError.cbg_Paymenttype}
                                                    required value={CnslBillGenValues.cbg_Paymenttype} onChange={cbg_PaymenttypeChangeHandle} id='paymentType'>
                                                    <option value={''}></option>
                                                    {billType.map((item) => (
                                                        <option value={item.paymentType}>{item.paymentType}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col><label className='billingIpTitle'>Rec_VoucherNo</label>
                                                <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bolder' }} id='vocherno'
                                                    value={CnslBillGenValues.cbg_RecVoucherNo} onChange={cbg_RecVoucherNoChangeHandle} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Bill Paid By</label>
                                                <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bolder' }} isInvalid={CnslBillGenError.cbg_BillPayby}
                                                    required value={CnslBillGenValues.cbg_BillPayby} onChange={cbg_BillPaybyChangeHandle} id='paidby'>
                                                    <option value=''></option>
                                                    {billPaidby.map((item) => (
                                                        <option value={item.billPaidBy}>{item.billPaidBy}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Voucher Type</label>
                                                <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bolder' }} isInvalid={CnslBillGenError.cbg_vouchertype}
                                                    required value={CnslBillGenValues.cbg_vouchertype} onChange={cbg_vouchertypeChangeHandle} id='vocherType'>
                                                    <option value={''}></option>
                                                    {VoucherType.map((item) => (
                                                        <option value={item.voucherType}>{item.voucherType}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col xs={4}><label className='billingIpTitle'>Voucher_Date</label>
                                                <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bolder' }} id='vocherDate'
                                                    type='date' value={CnslBillGenValues.cbg_VoucherDate} onChange={cbg_VoucherDateChangeHandle} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Bill PaidTo</label>
                                                <Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bolder' }} id='paidto'
                                                    required value={CnslBillGenValues.cbg_BillPaidto} onChange={cbg_BillPaidtoChangeHandle}>
                                                    <option value={''}></option>
                                                    {BillPaidTo.map((item) => (
                                                        <option value={item.billPaidTo}>{item.billPaidTo}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Printed Type</label>
                                                <Form.Select size='sm ' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bolder' }} isInvalid={CnslBillGenError.cbg_printedtype}
                                                    value={CnslBillGenValues.cbg_printedtype} onChange={cbg_printedtypeChangeHandle} id='printedType' >
                                                    <option value={''}></option>
                                                    {PrintedType.map((item) => (
                                                        <option value={item.printedType}>{item.printedType}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col><label style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bolder' }}>Bill Amount</label>
                                                <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bolder' }} id='billAmount'
                                                    value={CnslBillGenValues.cbg_BillAmount} onChange={cbg_BillAmountChangeHandle} />
                                            </Col>
                                        </Row>
                                        <Col className='mt-1 mb-1'>
                                            <label className='billingIpTitle'>Remarks</label>

                                            <center><Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '257px', height: '26px', textAlign: 'center', fontWeight: 'bolder' }} id='remarks'
                                                value={CnslBillGenValues.cbg_Remraks} onChange={cbg_RemraksChangeHandle} /></center>
                                        </Col>
                                        <div className='mt-4 mb-1 form-inline'>
                                            <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="primary" className='mt-1' disabled={saveDsa} onClick={saveConsoleBIling}>{save ? 'processing...' : 'Save'}</Button>{' '}
                                            <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="info" className='mt-1' disabled={UpdateDsa} onClick={UpdateConsoleBIling}>{Update ? 'processing...' : 'Update'}</Button>{' '}
                                            <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" disabled={DeleteDsa} onClick={deleteBilling}>{Delete ? 'processing..' : 'Delete'}</Button>{' '}
                                            <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" onClick={refresh}>Refresh</Button>{' '}
                                            <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" onClick={OpenViewJobHandle}>View Job Entry Details</Button>{' '}
                                        </div>
                                    </ItemPap>
                                </Grid>
                                <Grid item xs={3}>
                                    <ItemPap2 >
                                        <lable style={{ fontSize: '14px', fontFamily: 'Times New Roman', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%', marginRight: '50px' }}>Billing Job</lable>
                                        {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>  
                            <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /> </ToggleButton>  */}
                                        <TableContainer sx={{ maxHeight: 370 }} className='scrollbarPrime'>
                                            <Table stickyHeader className='table table-bordered'>
                                                <TableHead>
                                                    <StyledTableRow>
                                                        <StyledTableCell className='p-1'>Sl.No</StyledTableCell>
                                                        <StyledTableCell className='p-1'>Job No {billJobSrch()}</StyledTableCell>
                                                    </StyledTableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {Bill_Filtereddetails.map((item) => {
                                                        const isItemSelected = isSelected(item.consignmentId);
                                                        return (
                                                            <StyledTableRow hover key={item.consignmentNumber} tabIndex={-1} selected={isItemSelected} onClick={() => jobNonBilling(item)}>
                                                                <StyledTableCell className='p-1'>{item.serialNumber}</StyledTableCell>
                                                                <StyledTableCell className='p-1'>{item.consignmentNumber}</StyledTableCell>
                                                            </StyledTableRow>)
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </ItemPap2>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12}>
                                <Paper style={{ textAlign: 'center' }} sx={{ height: '250px' }}>
                                    <lable style={{ fontSize: '15px', fontFamily: 'Times New Roman', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%' }}>Console Billing Details</lable>
                                    <TableContainer className='scrollbarPrime' sx={{ maxHeight: 210 }}>
                                        <Table stickyHeader className='table table-bordered'>
                                            <TableHead>
                                                <StyledTableRow>
                                                    <StyledTableCell className='p-1'>JobNo</StyledTableCell>
                                                    <StyledTableCell className='p-1'>PaidBy</StyledTableCell>
                                                    <StyledTableCell className='p-1'>PaidTo</StyledTableCell>
                                                    <StyledTableCell className='p-1'>PaidDate</StyledTableCell>
                                                    <StyledTableCell className='p-1'>PaymentType</StyledTableCell>
                                                    <StyledTableCell className='p-1'>VoucherType</StyledTableCell>
                                                    <StyledTableCell className='p-1'>PrintedType</StyledTableCell>
                                                    <StyledTableCell className='p-1'>BillType</StyledTableCell>
                                                    <StyledTableCell className='p-1'>BillName</StyledTableCell>
                                                    <StyledTableCell className='p-1'>Amount</StyledTableCell>
                                                    <StyledTableCell className='p-1'>Remarks</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {ConsoleBilling.map((item) => (
                                                    <StyledTableRow hover key={item.consignmentId} onClick={() => editconsole(item)}>
                                                        <StyledTableCell className='p-1'>{item.consignmentId}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.billPaidBy}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.billPaidTo}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.billPaidDate}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.paymentType}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.voucherType}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.printedType}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.billType}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.billName}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.billAmount}</StyledTableCell>
                                                        <StyledTableCell className='p-1'>{item.remarks}</StyledTableCell>
                                                    </StyledTableRow>))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>}
            </div>
        </div>
    )
}

export default ConsleBillGen